import { AdsTxtStatus } from './adstxt-status.model';
import { Publisher } from './publisher.model';
import { DomainStatus } from './domain-status.enum';
import { DomainDpApproval, DomainDpStatus } from './domain-dp-approval.model';
import { DomainActivityStatus } from './domain-activity-status.model';
import { KeyLabel } from './key-label.model';
import { DpTier } from './dp-tier.enum';

export class Domain {

  id: string;
  name: string;
  storeUrl: string;
  bundle: string;
  ready: boolean;
  url: string;
  adstxtStatus: AdsTxtStatus;
  directAdstxtStatus: AdsTxtStatus;
  publisher: Publisher;
  defaultDomain: boolean;
  createdOn: string;
  activityStatus: DomainActivityStatus;
  status: DomainStatus;
  publisherId: string;
  managementUpdatedBy: string;
  managementUpdatedOn: string;
  rejectionReason: number;
  iamRejectedReason: number;
  management: DomainManagement;

  visits: number;
  tier: DpTier;
  bounceRate: number;
  visitDuration: number;

  adsTxtRequiredRecords: number;
  lastUpdatedOn: string;
  lastUpdatedBy: string;
  adsTxtMissingRecords: number;
  dpsApprovedCount: number;
  dpsCount: number;
  dpApprovals: DomainDpApproval[];
  _dpApprovalsMap: { [key: string]: DomainDpStatus };
  appAdsTxtDomain: string;
}

export enum DomainManagement {
  OWNED_AND_OPERATING = 'OWNED_AND_OPERATING',
  RESELLER = 'RESELLER'
}

export const DomainManagementLabels = {
  OWNED_AND_OPERATING: 'O&O',
  RESELLER: 'Reseller'
};

export const DomainManagementKL = () => Object.keys(DomainManagementLabels).map(key => new KeyLabel(key, DomainManagementLabels[key]));
